import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/dashboard.png'
import _imports_1 from '@/assets/icons/device.png'
import _imports_2 from '@/assets/icons/log.png'
import _imports_3 from '@/assets/icons/gear.png'


const _hoisted_1 = { class: "button is-light" }
const _hoisted_2 = {
  id: "app",
  class: "main-layout"
}
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-1" }
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = { class: "is-flex justify-content-center is-justify-content-space-around" }
const _hoisted_7 = { class: "menu-list" }
const _hoisted_8 = { class: "image is-48x48" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "image is-48x48" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "image is-48x48" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "image is-48x48" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { class: "section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_navbar_item = _resolveComponent("b-navbar-item")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_navbar, { type: "is-dark" }, {
      brand: _withCtx(() => [
        _createVNode(_component_b_navbar_item, {
          tag: "router-link",
          to: { path: '/' }
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" FermiCloud ", -1)
          ]))]),
          _: 1
        })
      ]),
      end: _withCtx(() => [
        _createVNode(_component_b_navbar_item, {
          disabled: "",
          label: $options.keycloak.idTokenParsed.preferred_username
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.keycloak.idTokenParsed.preferred_username), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_b_navbar_item, { tag: "div" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "buttons",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.keycloak.logout()))
            }, [
              _createElementVNode("a", _hoisted_1, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('global.logout')), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "menu-label" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  title: _ctx.$t('global.dashboard')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("figure", _hoisted_8, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "dashboard",
                        title: _ctx.$t('global.dashboard')
                      }, null, 8, _hoisted_9)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_router_link, {
                  to: "/projects",
                  title: _ctx.$t('global.projects')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "code",
                      class: "fa-2x",
                      size: "is-large"
                    })
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_router_link, {
                  to: "/devices",
                  title: _ctx.$t('global.devices')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("figure", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "devices",
                        title: _ctx.$t('global.devices')
                      }, null, 8, _hoisted_11)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_router_link, {
                  to: "/events",
                  title: _ctx.$t('global.events')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("figure", _hoisted_12, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: "events",
                        title: _ctx.$t('global.events')
                      }, null, 8, _hoisted_13)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_router_link, {
                  to: "/integrations",
                  title: _ctx.$t('global.integrations')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "puzzle-piece",
                      class: "fa-2x",
                      size: "is-large"
                    })
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_router_link, {
                  to: "/secrets",
                  title: _ctx.$t('global.secrets')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "key",
                      class: "fa-2x",
                      size: "is-large"
                    })
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_router_link, {
                  to: "/settings",
                  title: _ctx.$t('global.settings')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("figure", _hoisted_14, [
                      _createElementVNode("img", {
                        src: _imports_3,
                        alt: "integrations",
                        title: _ctx.$t('global.integrations')
                      }, null, 8, _hoisted_15)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_view)
          ])
        ])
      ])
    ])
  ], 64))
}